import { Cloud } from "@/components/icons"
import { cn } from "@/lib/utils"

type M365IconProps = {
  className?: string
  noText?: boolean
}

export function M365Icon({ className, noText = false }: M365IconProps) {
  if (noText) {
    return <Cloud className={cn("size-4", className)} strokeWidth={1.75} />
  }

  return (
    <div className={cn("inline-flex flex-col items-center justify-center leading-none", className)}>
      <Cloud className="size-4" strokeWidth={1.75} />
      <span className="-mt-0.5 text-[10px] font-semibold tracking-tight">365</span>
    </div>
  )
}
